import { T } from '@tribeplatform/react-components/i18n'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

export function UtilitySpacesRootTreeItem() {
  return (
    <div className="flex items-center gap-2 p-2">
      <SvgIcon name="file-lock-03" />
      <T id="Generics.UtilitySpaces" defaultMessage="Utility {SPACES}" />
    </div>
  )
}
